<template lang="pug">
  div.content__header(
    :class="{'content__header--empty': isEmpty}"
  )
    font-awesome-icon.content__help-icon(
      icon="question-circle"
      v-show="hasTutorial && !isAdmin"
      @click="onClickHelp"
    )
    h1(v-if="title")
      | {{ title }}
    p(v-if="introtext") {{ introtext }}
</template>

<style lang="scss" scoped>
.content {
  &__help-icon {
    display: block;
    margin-right: 8px;
    opacity: 0.5;
    cursor: pointer;
    font-size: 16px;

    &:hover {
      opacity: 1;
    }
  }
}

.content__header {
  position: relative;
  display: flex;
  align-items: center;

  h1 {
    padding: 0;
    margin: 0;
  }
}

@media screen and (max-width: 768px) {
  .content__header {
    padding: 0 12px;
  }
}
@media screen and (max-width: 480px) {
  .content__header {
    padding: 0 12px;
    white-space: nowrap;
    overflow: hidden;
  }
}
</style>

<script>
import { mapState } from 'vuex';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import EventBus from '@/eventBus';
library.add(faQuestionCircle);

export default {
  name: 'ContentHeader',

  computed: {
    ...mapState({
      isAdmin: state => state.user.profile.isAdmin
    }),

    title() {
      return this.$route.meta.title || null;
    },

    introtext() {
      return this.$route.meta.introtext || null;
    },

    isEmpty() {
      return this.title && this.introtext;
    },

    hasTutorial() {
      return !!this.$route.meta.tutorial;
    }
  },

  methods: {
    onClickHelp() {
      if (this.hasTutorial && this.$route.meta.tutorialStepId !== undefined) {
        EventBus.$emit('OPENTUTORIAL', this.$route.meta.tutorialStepId);
      }
    }
  },

  components: {
    FontAwesomeIcon
  }
};
</script>
